<template>
  <div class="layout">
    <Layout>
      <!-- <Sider breakpoint="md" style="background-color:#eee;height:800px;">
        <Tree :data="data3" ref="tree" :load-data="loadData" @on-select-change="tree_node" class="tree"></Tree>
        <Tree class="tree" @getData="getData"></Tree>
      </Sider> -->
      <Layout>
        <Header class="layout-header-bar" style="padding: 0 30px;line-height:40px;height:40px;">
          <Input
            suffix="ios-search"
            v-model="search_value"
            @on-search="search_station"
            search
            placeholder="请输入基站关键字"
            style="width: auto;margin-top:-1px;"
          />
        </Header>
        <Content :style="{margin: '20px', background: '#fff', minHeight: '220px'}">
          <div style="margin:10px;text-algin:center;">
            <RadioGroup v-model="border" type="button" style="margin-bottom:5px;">
                <Radio label="基站属性" border></Radio>
              <span @click="ditu">
              <Radio label="地图标注" border></Radio>
              </span>
            </RadioGroup>
            <Card>
              <Row>
                  <i-col span="10">
                      基站名称： <Input v-model="staName" placeholder="请输入基站名称" style="width:50%;"/>
                  </i-col>
                  <i-col span="10">
                      基站编号： <Input v-model="staNum" placeholder="请输入基站编号" style="width:50%;"/>
                  </i-col>
              </Row>
              <Row style="margin-top:10px;">
                  <i-col span="10">
                      描述： <Input v-model="staDesc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入基站描述..." style="width:50%;margin-left:24px;"/>
                  </i-col>
                  <i-col span="10">
                      通信信息： <Input v-model="staCommunication" placeholder="请输入通信信息" style="width:50%;"/>
                  </i-col>
                  <i-col span="4">
                      <Button type="primary" @click="save">保存</Button> 
                  </i-col>
              </Row> 
            </Card>
          </div>
          <Card style="margin:10px;">
            <div class="con-header">
              <Input
                suffix="ios-search"
                v-model="search_v"
                @on-search="search_s"
                search
                placeholder="请输入节点关键字"
                style="width: auto"
              />
              <Button type="error" @click="delData(1)" style="margin-left:10px;">批量删除</Button>
              <Button type="primary" style="margin-left:10px;" @click="newNustomer">新建节点</Button>
            </div>
            <div class="con-min">
              <Table
                border
                ref="selection"
                :columns="columns4"
                :data="data1"
                @on-selection-change="changeSelection"
              >
                <template slot-scope="{ row }" slot="name">
                  <strong>{{ row.name }}</strong>
                </template>
                <template slot-scope="{ index }" slot="action">
                  <Button
                    type="primary"
                    size="small"
                    style="margin-right: 5px"
                    @click="show(index)"
                  >编辑</Button>
                  <Button type="error" size="small" @click="remove(index)">删除</Button>
                </template>
              </Table>
              <!-- <Page
                class="pageBox"
                style="margin-top: 30px;text-align: center"
                :total="pageTotal"
                :current="page"
                :page-size="limit"
                @on-change="changePage"
              /> -->
            </div>
          </Card>
        </Content>
      </Layout>
    </Layout>
    <div>
      <Modal v-model="modal3" @on-ok="ok" @on-cancel="cancel" footer-hide>
        <Card style="width:100%;margin-top:30px;">
          <Form
            :model="formLeft"
            label-position="left"
            :label-width="100"
            style="margin-top:30px; width：80%"
          >
            <FormItem label="节点名称">
              <Input v-model="formLeft.nodeName" />
            </FormItem>
            <FormItem label="节点编号">
              <Input v-model="formLeft.nodeNum" placeholder="只支持数字"/>
            </FormItem>
            <FormItem label="描述">
              <Input v-model="formLeft.nodeDesc" />
            </FormItem>
            <FormItem label="通信信息">
              <Input v-model="formLeft.nodeCommunication" />
            </FormItem>
            <FormItem>
              <Button type="primary" @click="handleSubmit('formLeft')">确认</Button>
            </FormItem>
          </Form>
        </Card>
      </Modal>
    </div>
    <div>
      <Modal v-model="modal1" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除</span>
        </p>
        <div style="text-align:center">
          <p>是否要删除{{this.name}}</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long :loading="modal_loading" @click="del(0)">确认</Button>
        </div>
      </Modal>
      <Modal v-model="modal11" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除</span>
        </p>
        <div style="text-align:center">
          <p>是否要批量删除</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long :loading="modal_loading" @click="delAll(1)">确认</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>
<script>
import Tree from "./../../components/trees/deviceTree";
import api from "@/api/api";
import ap from "../../api/aipause";
import { globalBus } from '../../globals/globalBus';
export default {
  components: {
    Tree
  },
  data() {
    return {
      modal_loading: false,
      modal1: false,
      modal11:false,
      name:"",
      //搜索框的值
      search_value: "",
      search_v:"",
      //基站名称
      staName: "",
      //基站编号
      staNum: "",
      //描述
      staDesc: "",
      //通道信息
      staCommunication: "",
      clientId : "",
      //新建页面的数据
      formLeft: {
        staName: "",
        staNum: "",
        staDesc: "",
        staCommunication: "",
        // clientId : localStorage.getItem("clientId"),
        clientId : "",
        stationId : this.$route.params.id
      },
      modal3: false,
      //radio的值
      border: "基站属性",
      //列表的头
      columns4: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "节点编号",
          key: "nodeNum"
        },
        {
          title: "节点名称",
          key: "nodeName"
        },
        {
          title: "描述",
          key: "nodeDesc"
        },
        {
          title: "通信信息",
          key: "nodeCommunication"
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center"
        }
      ],
      //列表的数据
      data1: [],
      selectionId: [],
      //树节点的数据
      data3: [
        {
          title: "基站",
          loading: false,
          meta:{
                    belong:'project',
                   
                    },
          children: []
        },
        {
          title: "parent2",
          loading: false,
          children: []
        }
      ],
      path:[],
      idsAll:[]
    };
  },
  methods: {
    //搜索
    search_station() {
        this.$router.push({
         name:'index_station',
         query:{
            keyWord: this.search_value,
         }
      });
    },
    search_s() {
      if(this.search_v === ""){
        this.new()
      }else{
        ap("POST", "fuzzyQueryNodeList",{"keyword":this.search_v,"stationId":this.$route.params.id}).then(res =>{
          let data = res.data;
          if (data.code === 0) {
            this.data1 = data["page"]["list"];
            this.pageTotal = data["page"]["totalCount"];
          } else {
            this.$Message.error(data.msg);
          }
        })
      }
    },
    getData(e) {
      api.queryStationById({ id: this.$route.params.id }).then(res => {
        let data = res.data;
       
        if (data.code === 0) {
          if(e == 1){
              if(data.tStation.nodeList.length == 0){
                this.path = []
                this.path.push(
                  data.tStation.clientId,
                  data.tStation.resType,
                  data.tStation.id
                )
                globalBus.$emit('position',this.path);
              }else{
                this.path = []
                this.path.push(
                  data.tStation.clientId,
                  data.tStation.nodeList[(data.tStation.nodeList).length - 1].resType,
                  data.tStation.nodeList[(data.tStation.nodeList).length - 1].id
                )
                globalBus.$emit('position',this.path);
              }
            }else{
              if(data.tStation.nodeList.length == 0){
                this.path = []
                this.path.push(
                  data.tStation.clientId,
                  data.tStation.resType,
                  data.tStation.id
                )
                globalBus.$emit('position',this.path);
              }else{
                this.path = []
                this.path.push(
                  data.tStation.clientId,
                  data.tStation.nodeList[(data.tStation.nodeList).length - 1].resType,
                  data.tStation.nodeList[(data.tStation.nodeList).length - 1].id
                )
                globalBus.$emit('position',this.path);
              }
            }
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    //保存
    save(){
      if (!this.staName) return this.$Message.error("基站名称不能为空");
      if (!this.staNum) return this.$Message.error("基站编号不能为空");
      if (isNaN(this.staNum)) return this.$Message.error("基站编号只能为数字");
      if (!this.staCommunication) return this.$Message.error("通信信息不能为空");
      let user = this.$route.params.id;
      // if (!userId && !password) return this.$Message.error("密码不能为空");
      // if (password && password !== checkpassword) {
      //   return this.$Message.error("确认密码与密码输入不一致");
      // }

      // if (!mobile) return this.$Message.error("手机号不能为空");
      // if (!tel) return this.$Message.error("电话不能为空");
      // if (!email) return this.$Message.error("邮箱不能为空");
      // let params = Object.assign(
      //   {},
      //   {
      //     staName,
      //     staNum,
      //     staDesc,
      //     staCommunication,
      //     clientId,
      //   }
      // );
      api.updateStationById({ 
          id: user ,
          staName : this.staName,
          staNum : this.staNum,
          staDesc : this.staDesc,
          clientId : this.clientId ,
          staCommunication : this.staCommunication,
        }).then(res => {
          let data = res.data;
          if (data.code === 0) {
            this.$Message.success("更新成功");
            // this.$router.back();
            this.getstaId();
          } else {
            this.$Message.error(data.msg);
          }
        });
    },
    getstaId(){
      api.queryStationById({ id: this.$route.params.id }).then(res => {
        let data = res.data;
        if (data.code === 0) {
          this.path = []
          this.path.push(
            data.tStation.clientId,
            data.tStation.resType,
            data.tStation.id
          )
          globalBus.$emit('position',this.path);
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    //编辑的跳转
    show(index){
      //
      this.path = []
      this.path.push(
        this.data1[index].clientId,
        this.data1[index].resType,
        this.data1[index].id
      )
      globalBus.$emit('position',this.path);
      this.$router.push({
         path: `/device_management/node_properties/${this.data1[index].id}`
      });
    },
    //搜索基站的跳转
    device() {
      this.$router.replace({ name: "index_station" });
    },
    //地图标注的跳转
    ditu() {
      this.$router.replace({ 
        name: "ditu" ,
        params: {
            clientId : this.clientId,
        }
      });
    },
    //新建显示的页面
    newNustomer() {
      this.modal3 = true;
      this.formLeft.staCommunication = "";
      this.formLeft.staDesc = "";
      this.formLeft.staName = "";
      this.formLeft.staNum = "";
    },
    //新建页面的确定和取消
    ok() {
      
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.formLeft.nodeName) return this.$Message.error("节点名称不能为空");
      if (!this.formLeft.nodeNum) return this.$Message.error("节点编号不能为空");
      if (isNaN(this.formLeft.nodeNum)) return this.$Message.error("节点编号只能为数字");
      if (!this.formLeft.nodeDesc) return this.$Message.error("描述不能为空");
      if (!this.formLeft.nodeCommunication) return this.$Message.error("通信信息不能为空");
      let {
        nodeName,
        nodeNum,
        nodeDesc,
        nodeCommunication,
        clientId,
        stationId
      } = this.formLeft;
      // let user = this.formLeft.clientId;
      // if (!userId && !password) return this.$Message.error("密码不能为空");
      // if (password && password !== checkpassword) {
      //   return this.$Message.error("确认密码与密码输入不一致");
      // }

      // if (!mobile) return this.$Message.error("手机号不能为空");
      // if (!tel) return this.$Message.error("电话不能为空");
      // if (!email) return this.$Message.error("邮箱不能为空");
      let params = Object.assign(
        {},
        {
          nodeName,
          nodeNum,
          nodeDesc,
          nodeCommunication,
          clientId,
          stationId:this.$route.params.id,
        }
      );

      // if (user) {
        // !params["password"] && delete params["password"];
        // api.updateStationById({ ...params, userId: user }).then(res => {
        //   let data = res.data;
        //   if (data.code === 0) {
        //     this.$Message.success("更新成功");
        //     // this.$router.back();
        //     this.getData();
        //   } else {
        //     this.$Message.error(data.msg);
        //   }
        // });
      // } else {
        api
          .newNode({ ...params })
          .then(res => {
            let data = res.data;
            if (data.code === 0) {
              this.$Message.success("添加成功");
              this.modal3 = false;
              // this.$router.back();
              this.new()
              this.getData()
            } else {
              this.$Message.error(data.msg);
            }
          });
      // }
    },
    cancel() {
      //   this.$Message.info("取消编辑");
    },
    //删除
    remove(index) {
      this.modal1 = true;
      this.id = index;
      this.name = this.data1[index].nodeName;
    },
    del(e) {
      this.modal_loading = true;
      let id = this.data1[this.id].id;
      api.deleteNodeById([(this.id = id)]).then(res => {
        if (res.data.code === 0) {
          setTimeout(() => {
            this.modal_loading = false;
            this.modal1 = false;
            this.$Message.success("删除成功");
            this.new()
            this.getData(e)
          }, 2000);
        } else {
          setTimeout(() => {
            this.modal_loading = false;
            this.modal1 = false;
            this.$Message.success(res.data.msg);
            this.new()
            this.getData(e)
          }, 1000);
        }
      });
    },
    //树结构的数据
    loadData(item, callback) {
      setTimeout(() => {
        const data = [
          {
            title: "节点",
            loading: false,
            children: [
              {
                title: "通道",
                loading: false,
                children: [
                  {
                    title: "温度"
                  },
                  {
                    title: "振弦"
                  }
                ]
              }
            ]
          }
        ];
        callback(data);
      }, 1000);
    },
    // 复选框选中内容
    changeSelection(selection) {
      this.selectionId = [];
      selection.map(item => {
        this.selectionId.push(item.id);
      });
    },
    //批量删除
    delData(e, id) {
      let ids = [];
      if (id) {
        // 删除一个
        ids.push(id);
      } else {
        // 删除选中的所有
        if (this.selectionId.length > 0) {
          ids = this.selectionId;
          this.idsAll = ids
          this.modal11 = true;
        } else {
          this.$Message.error("没有要删除的角色");
        }
      }
    },
    delAll(e) {
      api.deleteNodeById(this.idsAll).then(res => {
        if (res.data.code === 0) {
          this.$Message.success("删除成功");
          this.modal11 = false;
          this.new()
          this.getData(e)
        } else {
          this.$Message.success(res.data.msg);
          this.modal11 = false;
        }
      });
    },
    new(){
      api.queryStationById({ id: this.$route.params.id }).then(res => {
        let data = res.data;
        if (data.code === 0) {
          this.staName = data.tStation.staName
          this.staNum = data.tStation.staNum
          this.staDesc = data.tStation.staDesc
          this.staCommunication = data.tStation.staCommunication
          this.clientId = data.tStation.clientId
          this.formLeft.clientId = data.tStation.clientId
          this.data1 = data["tStation"]["nodeList"];
        } else {
          this.$Message.error(data.msg);
        }
      });
    }
  },
  created(){
    //判断基站属性的ID
    // this.getDate();
    this.new()
    if(this.$route.params.id == "-1"){
        this.$Message["warning"]({
          content: '请返回基站索引，选择基站',
          duration: 3
        });
        setTimeout(()=>{
          this.$router.push({
            path: `/device_management/index_station`
          });
        },3000)
    }
  },
  watch: {
    '$route.params.id'(newval,oldval){
      this.new()
    },
  },
  computed: {}
};
</script>
<style scoped>
.layout {
  border: 1px solid #eeeeee;
  background: #eeeeee;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}
.tree {
  margin: 20px;
}
.con-header {
  margin: 10px;
}
.con-min {
  margin: 10px;
}
</style>